import Link from "next/link";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import Head from "next/head";
import Meta from "../Meta";
import {
  collectRenkingData,
  updateCollectionList,
  updateTrendingCategoryItemData,
} from "../../redux/marketplaceSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  getCollectionListings,
  getAllCollection,
  // getCollectionsByContract,
} from "../../utils/api";

import { DECIMAL } from "../../config";

const CollectionList = () => {
  const { filteredRenkingData, collectionList } = useSelector(
    (state) => state.marketplace
  );
  const dispatch = useDispatch();

  // console.log(collectionList);

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    if (scroll) {
      const scrollPosition = window.innerHeight + window.scrollY;
      const isScrollingDown = scrollPosition > lastScrollPosition;
      if (
        isScrollingDown &&
        scrollPosition >= document.body.offsetHeight &&
        collectionList.length % 100 == 0 &&
        !loading
      ) {
        console.log("Reached bottom of the page!");
        setLoading(true);
        fetchMoreItems();
      }
      lastScrollPosition = scrollPosition;
      setScroll(false);
    }
  }, [scroll]);

  const fetchMoreItems = async () => {
    const moreItems = await getAllCollection(page + 1);
    console.log(page + 1);

    if (moreItems.length > 0) {
      dispatch(updateCollectionList([...collectionList, ...moreItems]));
      setPage((prevPage) => prevPage + 1);
      setLoading(false);
    }
  };

  let lastScrollPosition = 0;

  const handleScroll = () => {
    setScroll(true);
  };

  useEffect(() => {
    getAllCollection(page).then((data) => {
      dispatch(updateCollectionList(data));
    });

    window.addEventListener("scroll", handleScroll);
    dispatch(updateTrendingCategoryItemData([]));

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch]);

  return (
    <>
      <Meta title="Nut Market " />
      {/* <!-- Rankings --> */}
      <section className="relative lg:mt-24 lg:pb-24 pb-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <Image
            src="/images/gradient_light.jpg"
            layout="fill"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <h1 className="font-display text-jacarta-700 py-8 text-center text-4xl font-medium dark:text-white">
            Collection
          </h1>

          {/* <!-- Filters --> */}
          <div className="mb-8 flex flex-wrap items-center justify-between">
            <div className="flex flex-wrap items-center">
              {/* <!-- Categories --> */}
              {/* <Recently_added_dropdown
                data={categoryText}
                dropdownFor="rankingCategories"
              /> */}

              {/* <!-- Chains --> */}
              {/* <Recently_added_dropdown
                data={blockchainText}
                dropdownFor="blockchain"
              /> */}
            </div>

            {/* last 7 days */}
            {/* <Recently_added_dropdown
              data={last7DaysRanks}
              dropdownFor="last7Days-ranks"
            /> */}

            {/* <!--  --> */}
          </div>
          {/* <!-- end filters --> */}

          {/* <!-- Table --> */}
          <div className="scrollbar-custom overflow-x-auto">
            <div
              role="table"
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 lg:rounded-2lg w-full min-w-[736px] border bg-white text-sm dark:text-white"
            >
              <div
                className="dark:bg-jacarta-600 bg-jacarta-50 rounded-t-2lg flex"
                role="row"
              >
                <div className="w-[28%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Collection
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Volume
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    24h %
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    7d %
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Floor Price
                  </span>
                </div>
                <div className="w-[12%] py-3 px-4" role="columnheader">
                  <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                    Owners
                  </span>
                </div>
              </div>
              {collectionList.map((item, index) => {
                const {
                  id,
                  image_url,
                  title,
                  totalvolume,
                  h24,
                  d7,
                  h24Color,
                  d7Color,
                  price,
                  floorprice,
                  owner,
                  name,
                  icon,
                  contract,
                  dayvolume,
                  weekvolume,
                } = item;

                return (
                  <Link href={`/collection/${contract}`} key={id + "/" + index}>
                    <a
                      className="flex transition-shadow hover:shadow-lg"
                      role="row"
                    >
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[28%] items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <span className="mr-2 lg:mr-4">{id}</span>
                        <figure className="relative mr-2 w-8 shrink-0 self-start lg:mr-5 lg:w-12">
                          {/* <img src={image} alt={title} className="rounded-2lg" loading="lazy" /> */}
                          <img
                            src={image_url}
                            alt={title}
                            height={32}
                            width={32}
                            layout="responsive"
                            objectfit="contain"
                            className="rounded-2lg"
                            loading="lazy"
                          />

                          {icon && (
                            <div
                              className="dark:border-jacarta-600 bg-green absolute -right-2 -bottom-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                              data-tippy-content="Verified Collection"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                className="h-[.875rem] w-[.875rem] fill-white"
                              >
                                <path fill="none" d="M0 0h24v24H0z"></path>
                                <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                              </svg>
                            </div>
                          )}
                        </figure>
                        <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                          {name}
                        </span>
                      </div>
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center whitespace-nowrap border-t py-4 px-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="SEI">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="/icons.svg#icon-SEI"></use>
                          </svg>
                        </span>
                        <span className="text-sm font-medium tracking-tight">
                          {totalvolume ? (totalvolume / DECIMAL).toFixed(4) : 0}
                        </span>
                      </div>
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <span className={`text-${h24Color}`}>
                          {dayvolume ? (dayvolume / DECIMAL).toFixed(4) : 0}
                        </span>
                      </div>
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <span className={`text-${d7Color}`}>
                          {weekvolume ? (weekvolume / DECIMAL).toFixed(4) : 0}
                        </span>
                      </div>
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <span className="-ml-1" data-tippy-content="SEI">
                          <svg className="icon mr-1 h-4 w-4">
                            <use xlinkHref="/icons.svg#icon-SEI"></use>
                          </svg>
                        </span>
                        <span className="text-sm font-medium tracking-tight">
                          {floorprice ? (floorprice / DECIMAL).toFixed(4) : 0}
                        </span>
                      </div>
                      <div
                        className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
                        role="cell"
                      >
                        <span>
                          {owner?.slice(0, 4)}...{owner?.slice(-3)}
                        </span>
                      </div>
                    </a>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end rankings --> */}
    </>
  );
};

export default CollectionList;
